import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveFinancialMonitoringMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientFinancialMonitoringEntity } from 'api/types/entity';

import { parseFinancialMonitoringParams, parseLegalClient } from './helpers';

export const useLegalClientSaveFinancialMonitoring = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveFinancialMonitoringMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveFinancialMonitoring
      ? parseLegalClient(data.legalClientSaveFinancialMonitoring)
      : undefined,
    loading,
    error,
    saveFinancialMonitoring: useCallback(
      async (id: string, params: LegalClientFinancialMonitoringEntity) => {
        const res = await handle({
          variables: {
            id,
            input: parseFinancialMonitoringParams(params),
          },
        });
        return res.data?.legalClientSaveFinancialMonitoring
          ? parseLegalClient(res.data.legalClientSaveFinancialMonitoring)
          : undefined;
      },
      [handle]
    ),
  };
};
